let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dyD4J")).then(() => parcelRequire('elHag'));